import limpiarHtml from "./limpiarHtml.js";

// Separa un text del CMS: el primer encapçalament és el títol i la resta és
// el contingut (ja netejat).
export default function separarTitol(html) {
    const doc = new DOMParser().parseFromString(limpiarHtml(html), "text/html");
    const encapcalament = doc.body.querySelector("h1, h2, h3, h4, h5, h6");
    const titol = encapcalament ? encapcalament.textContent.trim() : "";
    if (encapcalament) encapcalament.remove();
    return { titol, contingut: doc.body.innerHTML };
}
